 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLCONT from '@/components/xhtml/cont'
 import XHTMLINTRO from '@/components/xhtml/intro'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH01A from '@/components/xhtml/ch01a'
 import XHTMLCH01AA from '@/components/xhtml/ch01aa'
 import XHTMLCH01SUB01 from '@/components/xhtml/ch01sub01'
 import XHTMLCH01SUB02 from '@/components/xhtml/ch01sub02'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH02A from '@/components/xhtml/ch02a'
 import XHTMLCH02MAP from '@/components/xhtml/ch02map'
 import XHTMLCH02AA from '@/components/xhtml/ch02aa'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH03A from '@/components/xhtml/ch03a'
 import XHTMLCH03MAP from '@/components/xhtml/ch03map'
 import XHTMLCH03AA from '@/components/xhtml/ch03aa'
 import XHTMLCH03SUB01 from '@/components/xhtml/ch03sub01'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH04A from '@/components/xhtml/ch04a'
 import XHTMLCH04MAP from '@/components/xhtml/ch04map'
 import XHTMLCH04AA from '@/components/xhtml/ch04aa'
 import XHTMLCH04SUB01 from '@/components/xhtml/ch04sub01'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH05A from '@/components/xhtml/ch05a'
 import XHTMLCH05MAP from '@/components/xhtml/ch05map'
 import XHTMLCH05AA from '@/components/xhtml/ch05aa'
 import XHTMLCH05SUB01 from '@/components/xhtml/ch05sub01'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH06A from '@/components/xhtml/ch06a'
 import XHTMLCH06MAP from '@/components/xhtml/ch06map'
 import XHTMLCH06AA from '@/components/xhtml/ch06aa'
 import XHTMLCH06SUB01 from '@/components/xhtml/ch06sub01'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH07A from '@/components/xhtml/ch07a'
 import XHTMLCH07MAP from '@/components/xhtml/ch07map'
 import XHTMLCH07AA from '@/components/xhtml/ch07aa'
 import XHTMLCH07SUB01 from '@/components/xhtml/ch07sub01'
 import XHTMLCH07SUB02 from '@/components/xhtml/ch07sub02'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLSOURCES from '@/components/xhtml/sources'
 import XHTMLCOPY from '@/components/xhtml/copy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cont",
 			"name" : "xhtml/cont",
 			"component" : XHTMLCONT
 		},
 		{
 			"path" : "/xhtml/intro",
 			"name" : "xhtml/intro",
 			"component" : XHTMLINTRO
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch01a",
 			"name" : "xhtml/ch01a",
 			"component" : XHTMLCH01A
 		},
 		{
 			"path" : "/xhtml/ch01aa",
 			"name" : "xhtml/ch01aa",
 			"component" : XHTMLCH01AA
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js